<script lang="ts" setup>
import { rankingConfig as rocnovelConfig } from './configs/rocnovel'
import { rankingConfig as ocereadConfig } from './configs/oceread'
import { rankingConfig as talewaveConfig } from './configs/talewave'
import { rankingConfig as ficmoonConfig } from './configs/ficmoon'
import { rankingConfig as novelarcConfig } from './configs/novelarc'
import { rankingConfig as storyellaConfig } from './configs/storyella'
import { rankingConfig as aurenovelConfig } from './configs/aurenovel'
import { rankingConfig as florastoryConfig } from './configs/florastory'
import { rankingConfig as novelsprigConfig } from './configs/novelsprig'
import { rankingConfig as silktaleConfig } from './configs/silktale'
import { rankingConfig as pearlaConfig } from './configs/pearla'
import { rankingConfig as freeficConfig } from './configs/freefic'
import { rankingConfig as fictoraConfig } from './configs/fictora'
import { rankingConfig as marinovelConfig } from './configs/marinovel'
import { rankingConfig as flipnovelConfig } from './configs/flipnovel'
import { rankingConfig as moonpageConfig } from './configs/moonpage'
import { rankingConfig as storlynConfig } from './configs/storlyn'
import { rankingConfig as novarisConfig } from './configs/novaris'
import { rankingConfig as novelynConfig } from './configs/novelyn'
import { rankingConfig as novelmelloConfig } from './configs/novelmello'
import RankingPageDefault from './components/RankingPage.default.vue'
import RankingPageFicmoon from './components/RankingPage.ficmoon.vue'
import RankingPageNovelarc from './components/RankingPage.novelarc.vue'
import RankingPageNovelyn from './components/RankingPage.novelyn.vue'
import RankingPageFlipnovel from './components/RankingPage.flipnovel.vue'
import RankingPageTalewave from './components/RankingPage.talewave.vue'
import RankingPageNovelmello from './components/RankingPage.novelmello.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

defineProps<{
  columnId: string
}>()

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  talewave: talewaveConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  aurenovel: aurenovelConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  freefic: freeficConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  novelune: moonpageConfig,
  storlyn: storlynConfig,
  novaris: novarisConfig,
  novelyn: novelynConfig,
  novelmello: novelmelloConfig,
  novelsprig: novelsprigConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const RankingPage = loadBrandComponent({
  rocnovel: RankingPageDefault,
  oceread: RankingPageDefault,
  ficmoon: RankingPageFicmoon,
  novelarc: RankingPageNovelarc,
  storyella: RankingPageNovelarc,
  aurenovel: RankingPageNovelarc,
  florastory: RankingPageNovelarc,
  silktale: RankingPageNovelarc,
  pearla: RankingPageNovelarc,
  fictora: RankingPageFicmoon,
  marinovel: RankingPageDefault,
  talewave: RankingPageTalewave,
  flipnovel: RankingPageFlipnovel,
  moonpage: RankingPageFlipnovel,
  novelune: RankingPageFlipnovel,
  storlyn: RankingPageFlipnovel,
  novaris: RankingPageFlipnovel,
  novelyn: RankingPageNovelyn,
  novelmello: RankingPageNovelmello,
  novelsprig: RankingPageDefault,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <RankingPage :column-id="columnId" :config="config" />
  </div>
</template>
